<template>
  <div class="fillet">
    <div class="retrieval">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <!-- 搜索栏最左侧 -->
        <slot name="start"></slot>
        <slot name="monthTab"></slot>
        <!-- 循环生成搜索控件 -->
        <FormItem v-for="(c, i) in formCtrl" :key="'search' + i" :config="c" :options="c.options"
          :inputValue="form[c.keyName]" @onChange="onChange" />
        <!-- 按钮前 -->
        <slot name="beforeBtn"></slot>
        <!-- 搜索按钮 -->
        <el-form-item v-if="!hideBtns">
          <el-button type="primary" @click="onSubmit" icon="el-icon-search">搜索</el-button>
        </el-form-item>
        <el-form-item v-if="!hideBtns">
          <el-button plain @click="onReset">重置</el-button>
        </el-form-item>
        <!-- 搜索栏最右侧 -->
        <slot name="end"></slot>
      </el-form>
      <div class="right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchField",
  props: {
    form: Object,
    formCtrl: Array,
    hideBtns: Boolean,
  },
  methods: {
    onChange({ key, value }) {
      // console.log(key, value)
      this.form[key] = value;
      // console.log({ ...this.form });
      this.$emit("onChange", { key, value });
    },
    onSubmit() {
      // console.log("search");
      this.$emit("onSearch", this.form);
    },
    onReset() {
      // console.log("reset");
      this.$emit("onReset");
    },
  },
};
</script>

<style lang="less" scoped>
.el-form--inline {
  .item {
    margin-right: 20px;
  }

  // .el-form-item {
  //   margin-right: 20px;
  // }
}

// .el-form--inline .el-form-item:nth-last-child(2) {
//   margin-right: 10px;
// }

// .el-form--inline .el-form-item:nth-last-child(3) {
//   margin-right: 20px;
// }


.fillet {
  height: auto;
  /* overflow: hidden; */
  margin: 0 auto;
  padding: 20px 0px 10px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
}

.retrieval {
  height: auto;
  /* overflow: hidden; */
  margin: 0px 20px;
  font-size: 14px;
  color: #606266;
  display: flex;
  justify-content: space-between;

  .el-form {
    flex: 1;
  }

  /deep/ .el-input {
    width: 150px;
  }

  /deep/ .startBtn {
    margin-right: 30px;
  }
}

.el-form .el-input__inner {
  width: 150px;
}
</style>
